import { render, staticRenderFns } from "./Skupovi.vue?vue&type=template&id=b59cb20a&scoped=true&"
import script from "./Skupovi.vue?vue&type=script&lang=js&"
export * from "./Skupovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59cb20a",
  null
  
)

export default component.exports